import OfferTechAnalysis from './OfferTechAnalysis';

export default OfferTechAnalysis;
